import React from 'react';
import { GridSelect } from 'components/FeaturedSpreadsheet/components';
import { OwnershipDataEditorProps } from './OwnershipDataEditor.props';
import { useCashFlowContext } from '../context/CashFlowContext';

const OwnershipDataEditor = (props: OwnershipDataEditorProps) => {
  const { ownershipOptions } = useCashFlowContext();

  return <GridSelect menuPosition="fixed" usePortal options={ownershipOptions} {...props} />;
};

export default OwnershipDataEditor;
